import axios from 'axios';
import promise from 'promise';

import { USER_LOCAL_KEY } from '../modules/agent';
import storage from './storage';

axios.defaults.baseURL = 'https://ncltaimprintintl.com/api';

axios.interceptors.request.use((config) => {
    const user = storage.getItem(USER_LOCAL_KEY);
    const token = user && user.tokenId;

    //if token is found add it to the header
    if (token) {
        config.headers['Authorization'] = `${token}`;
    }

    return config;
}, (error) => promise.reject(error));



// WEBPACK FOOTER //
// ./src/helpers/configure-axios.js